import { Box, Button, Divider, Typography, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { CustomPaperHeader, DetailsIconBox } from './style';
import RoundRingIcon from '../../icons/RoundRingIcon';
import TodoTasks from './TodoTasks';
import NoDataPresentUI from '../../components/NoDataPresentUI';
import FilledTickIcon from '../../icons/FilledTickIcon';
import RenderContent from '../../components/RenderContent';

import RecommendedProvider from '../../components/RecommendedProvider';
import DeleteIcon from '@mui/icons-material/Delete';

export function RightPaperBox({ currentSelectedItem, setCurrentSelectedItem, selectedItemDetails, updateChecklists, openDeleteTaskModal }) {
    const theme = useTheme();

    const isMobileView = useMediaQuery(theme.breakpoints.down('sm'));

    const createMarkup = (text) => {
        return { __html: text };
    };

    if (!currentSelectedItem.id) {
        return (
            <NoDataPresentUI
                component={Box}
                containerSx={{
                    // minWidth: '400px',
                    width: '100%',
                    // gap:"0",

                    [theme.breakpoints.down('sm')]: {
                        display: 'none',
                    },
                }}
                heading="Select a task to view more information"
                icon={<Box component={'img'} src="/images/other/cropped_click_on_task.png" sx={{ width: '100px', height: '130px' }} alt="no task clicked yet"></Box>}
            />
        );
    }

    const updateTaskStatus = (newTaskList) => {
        let newSelectedItem = { ...currentSelectedItem, companyTasks: newTaskList };
        setCurrentSelectedItem(newSelectedItem);
        updateChecklists(newSelectedItem);
    };

    return (
        <Box
            className="right-content"
            sx={{
                width: '100%',
                height: '100%',
                overflow: 'auto',
                minWidth: '400px',

                [theme.breakpoints.down('md')]: {
                    minWidth: 'unset',

                    // display: 'none',
                    width: '100%',
                },

                [theme.breakpoints.down('sm')]: {
                    minWidth: 'unset',

                    // display: 'none',
                    width: '100%',
                },
            }}
        >
            <CustomPaperHeader
                headingText={currentSelectedItem.name}
                // icon={getDetailsTag(currentSelectedItem)}
                icon={null}
                rightSideButton={
                    <Button
                        variant="outlined"
                        color="error"
                        startIcon={<DeleteIcon />}
                        sx={{ whiteSpace: 'nowrap', minWidth: 'unset', marginLeft: { sm: '4px' }, marginTop: { xs: '10px', sm: '0' }, fontSize: '14px' }}
                        onClick={(event) => {
                            event.stopPropagation();
                            openDeleteTaskModal(currentSelectedItem);
                        }}
                    >
                        Remove task
                    </Button>
                }
                iconSx={{
                    padding: 0,
                    marginRight: '0.5rem',
                }}
                sx={{
                    alignItems: {
                        xs: 'start',
                        sm: 'center',
                    },
                }}
            />
            <Divider
                sx={{
                    marginBottom: theme.typography.generic.xLarge,
                    marginLeft: '24px',
                    marginRight: '24px',
                }}
            />

            <TodoTasks
                todoItemList={[...currentSelectedItem?.companyTasks]}
                currentSelectedItem={currentSelectedItem}
                setCurrentSelectedItem={setCurrentSelectedItem}
                selectedItemDetails={selectedItemDetails}
                updateTaskStatus={updateTaskStatus}
            />
            <Box
                sx={{
                    padding: `${theme.typography.generic.none} ${theme.typography.generic.xxxLarge}`,
                }}
            >
                {currentSelectedItem.shortDescription && (
                    <Box>
                        <Typography component="h5" variant="paraText1" color="text.secondary" marginBottom={theme.typography.generic.xSmall}>
                            {'Description'}
                        </Typography>
                        <Typography component="p" variant="paraText3" color="text.secondary">
                            <RenderContent htmlString={currentSelectedItem.shortDescription} />
                        </Typography>
                    </Box>
                )}

                {currentSelectedItem.longDescription && (
                    <Box>
                        <Typography
                            component="h5"
                            variant="paraText1"
                            color="text.secondary"
                            margin={`${theme.typography.generic.xLarge} ${theme.typography.generic.none} ${theme.typography.generic.xSmall} ${theme.typography.generic.none}`}
                        >
                            {'Key Details'}
                        </Typography>

                        <RenderContent htmlString={currentSelectedItem.longDescription} />
                    </Box>
                )}
            </Box>
            {/* <Divider
                sx={{
                    margin: `${theme.typography.generic.xLarge} ${theme.typography.generic.none}`,
                }}
            /> */}

            <Box
                sx={{
                    margin: `${theme.typography.generic.xLarge} ${theme.typography.generic.none}`,
                }}
            ></Box>

            <RecommendedProvider solutionSuggestedTaskId={currentSelectedItem.solutionSuggestedTaskId}></RecommendedProvider>
        </Box>
    );
}

export default RightPaperBox;
